// ** Initial State
const initialState = {
  mails: [],
  filtered_mails: [],
  params: {},
  currentMail: null,
  emailsMeta: {},
  selectedMails: [],
  folderTree: {},
  staffData: [],
  referenceEmail: '',
  emailLoader: false
}

const EmailReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_MAILS':
      // ** If currentMail is not null / undefined then find and set currentMail
      let currMail = null
      if (state.currentMail !== null && state.currentMail !== undefined) {
        currMail = action.data.emails.find(i => i.UID === state.currentMail.UID)
      }
      return {
        ...state,
        mails: action.data.emails,
        emailsMeta: action.data.emailsMeta,
        params: action.params,
        currentMail: currMail
      }
    case "SET_EMAIL_LOADER":
      return { ...state, emailLoader: action.data }
    case 'PAGINATE_MAIL':
      // ** Find current mail & add hasNextMail & hasPreviousMail props to current mail object based on index
      const data = action.data
      const dataIndex = state.mails.findIndex(i => i.id === data.id)
      dataIndex === 0 ? (data.hasPreviousMail = false) : (data.hasPreviousMail = true)
      dataIndex === state.mails.length - 1 ? (data.hasNextMail = false) : (data.hasNextMail = true)
      return { ...state, currentMail: data }

    case 'UPDATE_MAILS':
      // // ** Find and updated mail   
      const mails = state.mails
      function updateMailData(email) {
        Object.assign(email, action.dataToUpdate)
      }
      mails.forEach(email => {
        if (action.emailIds.includes(email.id)) updateMailData(email)
      })
      return { ...state, mails }

    /** Add email to star and unstar **/
    case 'ADD_TO_IMPORTANT_MAIL':
      const all_mails = state.mails.map((email) => {
        if (email.EmailNo === action.data.EmailNo) {
          return { ...email, isStared: action.data.isStared }
        } else {
          return email
        }
      })
      const all_filter_mails1 = state.filtered_mails.map((email) => {
        if (email.EmailNo === action.data.EmailNo) {
          return { ...email, isStared: action.data.isStared }
        } else {
          return email
        }
      })
      return { ...state, mails: all_mails, filtered_mails: all_filter_mails1 }

    /** search from current mail list **/
    case 'SEARCH_FROM_MAIL_LIST':
      if (action.data) {
        const value = action.data
        const all_filtered_mails = state.mails.filter(item => {
          const startsWithCondition =
            (item.EmailFrom && item?.EmailFrom?.toLowerCase().startsWith(value.toLowerCase())) ||
            (item.Subject && item?.Subject?.toLowerCase().startsWith(value.toLowerCase()))
          const includesCondition =
            (item.EmailFrom && item?.EmailFrom?.toLowerCase().includes(value.toLowerCase())) ||
            (item.Subject && item?.Subject?.toLowerCase().includes(value.toLowerCase()))
          if (startsWithCondition) {
            return startsWithCondition
          } else if (!startsWithCondition && includesCondition) {
            return includesCondition
          } else return null
        })
        return { ...state, filtered_mails: all_filtered_mails }
      } else {
        return { ...state, filtered_mails: [] }
      }

    // ** Select mails
    case 'UPDATE_MAIL_LABEL':
      return { ...state }
    case 'SELECT_CURRENT_MAIL':
      return { ...state, currentMail: action.mail }

    case 'SELECT_ALL_MAIL':
      // ** Select all mails
      const selectAllMails = []
      if (action.val) {
        selectAllMails.length = 0
        state.mails.forEach(mail => {
          selectAllMails.push(mail.EmailNo)
        })
      } else {
        selectAllMails.length = 0
      }
      return { ...state, selectedMails: selectAllMails }
    case 'RESET_SELECT_MAILS':
      // ** Reset(remove) all selected mails
      return { ...state, selectedMails: [] }
    case 'RESET_MAILS':
      // ** Reset(remove) all selected mails
      return { ...state, mails: [] }
    case 'SELECT_MAIL': {
      const prev = state.selectedMails
      const next = prev.includes(action.id) ? prev.filter(id => id !== action.id) : [...prev, action.id]
      return { ...state, selectedMails: next }
    }
    case 'SELECT_MAILS_BATCH': {
      const next = [...state.selectedMails]
      if (action.selected) {
        action.ids.forEach(id => { if (!next.includes(id)) next.push(id) })
      } else {
        action.ids.forEach(id => { const idx = next.indexOf(id); if (idx !== -1) next.splice(idx, 1) })
      }
      return { ...state, selectedMails: next }
    }

    //case remove mails

    case 'REMOVE_MAIL':
      const allMails = state.mails
      function removeId(email) {
        allMails.splice(allMails.indexOf(email), 1)
      }
      allMails.forEach(email => {
        if (action.ids.includes(email.EmailNo)) removeId(email)
      })
      return { ...state, mails: allMails }

    //get doc center data 
    case 'GET_ATTACHED_DOC':
      return { ...state, folderTree: action.data }

    //get staff data for email
    case 'GET_STAFF_DATA':
      return { ...state, staffData: action.data }
    // get reference mail
    case 'GET_REFERENCE_MAIL':
      return { ...state, referenceEmail: action.id }
    default:
      return state
  }
}

export default EmailReducer
